// import Swiper bundle with all modules installed
import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

// GSAP Plugins
// gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // console.log('DLA FIRM');

    const kawaBtn = $('#carousel-btn-kawa');
    const herbataBtn = $('#carousel-btn-herbata');
    const kawaNav = $('#nav-btns-kawa');
    const herbataNav = $('#nav-btns-herbata');
    const kawaCarousel = $('#kawa-container');
    const herbataCarousel = $('#herbata-container');

    kawaBtn.on('click', function () {
      console.log('KAWA CLICK');
      if (!$(this).hasClass('active')) {
        $('.carousel-category-btn').removeClass('active');
        $('.carousel-nav-btns').removeClass('active');
        $(this).addClass('active');
        herbataNav.fadeOut();
        kawaNav.fadeIn();
        herbataCarousel.removeClass('active');
        kawaCarousel.delay(300).addClass('active');
      }
    });
    herbataBtn.on('click', function () {
      console.log('HERBATA CLICK');
      if (!$(this).hasClass('active')) {
        $('.carousel-category-btn').removeClass('active');
        $('.carousel-nav-btns').removeClass('active');
        $(this).addClass('active');
        kawaNav.fadeOut();
        herbataNav.fadeIn();
        kawaCarousel.removeClass('active');
        herbataCarousel.delay(300).addClass('active');
      }
    });

    new Swiper('.kawa-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      // loop: true,
      navigation: {
        nextEl: '.button-prev-kawa',
        prevEl: '.button-next-kawa',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
    });
    new Swiper('.herbata-container', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      // loop: true,
      navigation: {
        nextEl: '.button-prev-herbata',
        prevEl: '.button-next-herbata',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/dla-firm.js